import React from 'react'
import SnippeSection from './SnippeSection'

export default function Css() {
    let a = ["display: flex; \n", "align-items: center;\n", "justify-content: center;"]
    let b = ["margin: 0px;\n", "padding: 0px;"]
    let c = ["padding:10px;\n", "border-radius:10px;\n", "border:none;\n", "outline:none;\n", "background: //code"]
    return (
        <>
            <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>Css</h1>
            <SnippeSection title="fl - Flex Align-Items Justify-Content" locate="" code={a} />
            <SnippeSection title="m0p0 - Defaults For a new Page" locate="right" code={b} />
            <SnippeSection title="btn - A Button UI Most Used By Me" locate="" code={c} />
        </>
    )
}
